import { Link } from 'react-router-dom'

export const ARTICLE_TAG_ICONS = {
    article: 'icon-description-outline',
    audio: 'icon-play-circle-outline',
    equity: 'icon-balance',
    fundraising: 'icon-paid',
    innovation: 'icon-tips-and-updates',
    'issues-in-education': 'icon-school',
    methods: 'icon-construction',
    research: 'icon-biotech',
    'product-development': 'icon-category',
    'sales-marketing': 'icon-trending-up',
    'venture-development': 'icon-handshake',
    video: 'icon-play-circle-outline'
}

export default function ArticleIconTags (props = {
    durations: null,
    tags: null,
    svgProps: null,
    containerClassName: null,
    hideTags: null,
    linkTags: null
}) {
    const {
        id,
        durations,
        tags,
        svgProps,
        containerClassName,
        hideTags,
        linkTags,
        ...renderProps
    } = props

    if (!Array.isArray(tags)
            || !tags.length)
        return null

    const slugs = tags
        .map(obj => obj.slug)
        .filter(str => str)

    const getSlugIndex = (str) => slugs.indexOf(str)

    const isVideo = getSlugIndex('video') > getSlugIndex('audio')
        && getSlugIndex('video') > getSlugIndex('article')

    const isAudio = getSlugIndex('audio') > getSlugIndex('video')
        && getSlugIndex('audio') > getSlugIndex('article')

    const isText = !isVideo
        && !isAudio

    const icon = ARTICLE_TAG_ICONS[isText ? 'article' : 'audio']

    const getUniqueTags = () => tags
        .filter(obj =>
            !(obj.slug || '').match(/(article|audio|video)/))

    const tagsDisplay = getUniqueTags().length
        ? getUniqueTags()
        : tags

    const durationMS = durations
        ? ((durations.video || 0) + (durations.audio || 0) + (isText
            ? durations.text || 0
            : 0)) * 1000
        : 0

    let duration = ''

    if (durationMS > 3600000)
        duration += `${Math.floor((durationMS / (1000 * 60 * 60)) % 24)}H `

    if (durationMS > 0)
        duration += `${Math.round((durationMS / (1000 * 60)) % 60)}M`

    duration = duration.replace(/\s+0M$/, '')

    if (duration === '0M')
        duration = ''

    return (
        <div
            id={id || null}
            className={`article-meta${
                containerClassName
                    ? ` ${containerClassName}`
                    : ''}`}
        >
            {duration
                && (
                    <p
                        {...renderProps}
                    >
                        <svg
                            className={`flex-none ${icon}`}
                            width="18"
                            height="18"
                            aria-label={isVideo || isAudio
                                ? durations
                                        && durations.video
                                        && durations.audio
                                    ? 'Media'
                                    : (isVideo
                                        ? 'Video'
                                        : 'Audio')
                                : null}
                            style={{ maxHeight: '18px' }}
                            {...svgProps}
                        >
                            <use
                                xlinkHref={`#${icon}`}
                            />
                        </svg>
                        <span
                            className="flex-none"
                            style={{ paddingLeft: '5px' }}
                        >
                            <span className="text-screen-reader">
                                {isText ? 'Read time' : 'Duration'}:
                            </span>
                            <time
                                dateTime={`PT${duration.replace(/\s/g, '')}`}
                            >
                                <span>{duration.toLowerCase()}</span>
                                <span style={{ opacity: 0 }}>.</span>
                            </time>
                        </span>
                    </p>
                )}
            {!hideTags
                && (
                    <p
                        className={`body-5 article-card-tags${
                            !duration
                                ? ' margin-0-t'
                                : ''}`}
                    >
                        <span className="text-screen-reader">Tags:</span>
                        {tagsDisplay
                            .map((obj, key) => !linkTags
                                ? (
                                    <span
                                        key={key}
                                        className="article-card-tag"
                                    >
                                        {obj.title}
                                    </span>)
                                : (
                                    <Link
                                        key={key}
                                        className="article-card-tag text-decoration-hover"
                                        to={`/dashboard/hub/search?${
                                            obj.slug.match(/(article|audio|video)/)
                                                ? 'media'
                                                : 'topic'}=${
                                            obj.slug}`}
                                    >
                                        <span>
                                            {obj.title}
                                        </span>
                                    </Link>))}
                        <span style={{ opacity: 0 }}>.</span>
                    </p>)}
        </div>
    )
}
